// ;(function($, window, document, undefined) {
//   function callback() {
//     exports.value = "aaa";

    
//     // exports.success = function(str){success(str)}; 
//     // exports.failed = function(str){failed(str)}; 
//   }
        
// })(window.Zepto || window.jQuery, window, document);

var ANDROID_CALLBACK_LOG_PREFIX = '[Android Callback]';

function logAndroidCallback(eventName, nativeMethod, payload) {
  var entry = {
    event: eventName,
    nativeMethod: nativeMethod || eventName,
    time: new Date().toISOString(),
    androidAvailable: typeof Android !== 'undefined',
  };
  if (payload !== undefined && payload !== null) {
    if (typeof payload === 'object') {
      entry.payload = payload;
    } else {
      entry.pipe = String(payload);
    }
  }
  console.log(ANDROID_CALLBACK_LOG_PREFIX, entry);
}

function successCallback(str){
  logAndroidCallback('success', 'Android.success', str);
  Android.success(str);
}
function doPurchaseCallback(str){
  logAndroidCallback('doPurchase', 'Android.doPurchase', str);
  Android.doPurchase(str)
}
function pendingCallback(str){
  logAndroidCallback('pending', 'pendingCallback', str);
  pendingCallback(str)
}
// Android Interface to trigger file url for android to enable download
function doDownloadInvoice(storedTransactionId,fileName) {
    logAndroidCallback('doDownloadInvoice', 'Android.doDownloadInvoice', {
      storedTransactionId: storedTransactionId,
      fileName: fileName,
    });
     Android.doDownloadInvoice(storedTransactionId,fileName);
}
// function npawSuccessCallback(val){
//   Android.npawSuccessCallback(val);
// }

function failedCallback(str){
  logAndroidCallback('failed', 'Android.failed', str);
  Android.failed(str);
}

function cancelledCallback(str) {
  if (typeof Android !== 'undefined' && Android.subscription_cancelled) {
    logAndroidCallback('subscription_cancelled', 'Android.subscription_cancelled', str);
    Android.subscription_cancelled(str);
  } else {
    console.warn(ANDROID_CALLBACK_LOG_PREFIX, {
      event: 'subscription_cancelled',
      nativeMethod: 'Android.subscription_cancelled',
      time: new Date().toISOString(),
      androidAvailable: typeof Android !== 'undefined',
      pipe: str,
      skipped: true,
      reason: 'Android.subscription_cancelled not available',
    });
  }
}

// --- Android ↔ Web analytics payloads (WebEngage-aligned) ---
// Web stores values when an event fires; Android can read via evaluateJavascript getters below.
window.__androidEventPayloads = window.__androidEventPayloads || {
  checkout_failed: { pipe: '', json: '' },
  subscription_cancelled: { pipe: '', json: '' },
  payment_failed: { pipe: '', json: '' },
  subscription_failure: { pipe: '', json: '' },
};

function publishAndroidCheckoutFailed(pipeStr, jsonStr) {
  window.__androidEventPayloads.checkout_failed = {
    pipe: pipeStr || '',
    json: jsonStr || '',
  };
  if (typeof Android !== 'undefined' && Android.checkout_failed) {
    logAndroidCallback('checkout_failed', 'Android.checkout_failed', {
      pipe: pipeStr,
      json: jsonStr,
    });
    Android.checkout_failed(pipeStr);
  } else if (typeof Android !== 'undefined' && Android.failed) {
    logAndroidCallback('checkout_failed', 'Android.failed (fallback)', {
      pipe: pipeStr,
      json: jsonStr,
    });
    Android.failed(pipeStr);
  } else {
    console.warn(ANDROID_CALLBACK_LOG_PREFIX, {
      event: 'checkout_failed',
      time: new Date().toISOString(),
      androidAvailable: false,
      pipe: pipeStr,
      json: jsonStr,
      skipped: true,
    });
  }
}

function publishAndroidSubscriptionCancelled(pipeStr, jsonStr) {
  window.__androidEventPayloads.subscription_cancelled = {
    pipe: pipeStr || '',
    json: jsonStr || '',
  };
  if (typeof Android !== 'undefined' && Android.subscription_cancelled) {
    logAndroidCallback('subscription_cancelled', 'Android.subscription_cancelled', {
      pipe: pipeStr,
      json: jsonStr,
    });
    Android.subscription_cancelled(pipeStr);
  } else {
    console.warn(ANDROID_CALLBACK_LOG_PREFIX, {
      event: 'subscription_cancelled',
      time: new Date().toISOString(),
      androidAvailable: typeof Android !== 'undefined',
      pipe: pipeStr,
      json: jsonStr,
      skipped: true,
      reason: 'Android.subscription_cancelled not available',
    });
  }
}

/** Android: webView.evaluateJavascript("getAndroidCheckoutFailedPayloadPipe()", ...) */
function getAndroidCheckoutFailedPayloadPipe() {
  return window.__androidEventPayloads.checkout_failed.pipe || '';
}

/** Android: returns JSON string of WebEngage "Checkout Failed" fields */
function getAndroidCheckoutFailedPayload() {
  return window.__androidEventPayloads.checkout_failed.json || '';
}

function getAndroidSubscriptionCancelledPayloadPipe() {
  return window.__androidEventPayloads.subscription_cancelled.pipe || '';
}

function getAndroidSubscriptionCancelledPayload() {
  return window.__androidEventPayloads.subscription_cancelled.json || '';
}

function publishAndroidPaymentFailed(pipeStr, jsonStr) {
  window.__androidEventPayloads.payment_failed = {
    pipe: pipeStr || '',
    json: jsonStr || '',
  };
  if (typeof Android !== 'undefined' && Android.payment_failed) {
    logAndroidCallback('payment_failed', 'Android.payment_failed', {
      pipe: pipeStr,
      json: jsonStr,
    });
    Android.payment_failed(pipeStr);
  } else {
    console.warn(ANDROID_CALLBACK_LOG_PREFIX, {
      event: 'payment_failed',
      time: new Date().toISOString(),
      androidAvailable: typeof Android !== 'undefined',
      pipe: pipeStr,
      json: jsonStr,
      skipped: true,
      reason: 'Android.payment_failed not available',
    });
  }
}

function getAndroidPaymentFailedPayloadPipe() {
  return window.__androidEventPayloads.payment_failed.pipe || '';
}

function getAndroidPaymentFailedPayload() {
  return window.__androidEventPayloads.payment_failed.json || '';
}

function publishAndroidSubscriptionFailure(pipeStr, jsonStr) {
  window.__androidEventPayloads.subscription_failure = {
    pipe: pipeStr || '',
    json: jsonStr || '',
  };
  if (typeof Android !== 'undefined' && Android.subscription_failure) {
    logAndroidCallback('subscription_failure', 'Android.subscription_failure', {
      pipe: pipeStr,
      json: jsonStr,
    });
    Android.subscription_failure(pipeStr);
  } else {
    console.warn(ANDROID_CALLBACK_LOG_PREFIX, {
      event: 'subscription_failure',
      time: new Date().toISOString(),
      androidAvailable: typeof Android !== 'undefined',
      pipe: pipeStr,
      json: jsonStr,
      skipped: true,
      reason: 'Android.subscription_failure not available',
    });
  }
}

function getAndroidSubscriptionFailurePayloadPipe() {
  return window.__androidEventPayloads.subscription_failure.pipe || '';
}

function getAndroidSubscriptionFailurePayload() {
  return window.__androidEventPayloads.subscription_failure.json || '';
}
// function npawFailedCallback(val){
//   Android.npawFailedCallback(val);
// }

// function initCallBack(str){
//   Android.init(str);
// }
function initCallBack(str) {
  if (typeof Android !== 'undefined' && Android.init) {
    logAndroidCallback('init', 'Android.init', str);
    Android.init(str);
  } else {
    console.warn(ANDROID_CALLBACK_LOG_PREFIX, {
      event: 'init',
      nativeMethod: 'Android.init',
      time: new Date().toISOString(),
      androidAvailable: typeof Android !== 'undefined',
      pipe: str,
      skipped: true,
      reason: 'Android.init not available',
    });
  }
}

// function initCallNpaw(val){
//   Android.initCallNpaw(val);
// }
// new android fn for incorrect coupon code
function incorrectCouponcode(str){
  logAndroidCallback('incorrectCoupon', 'Android.incorrectCoupon', str);
  Android.incorrectCoupon(str);
}

function sessionExpiredAndroid(){
  logAndroidCallback('sessionExpired', 'Android.sessionExpiredAndroid');
  Android.sessionExpiredAndroid();
}
function showAndroidPopup(){
  logAndroidCallback('showAndroidPopup', 'Android.showAndroidPopup');
  Android.showAndroidPopup();
}
function redictionBack(){
  logAndroidCallback('redictionBack', 'Android.redictionBack');
  Android.redictionBack();
}
function plansredictionBack(){
  logAndroidCallback('plansredictionBack', 'Android.plansredictionBack');
  Android.plansredictionBack();
}
function androidRegionCheck(){
  logAndroidCallback('androidRegionCheck', 'Android.androidRegionCheck');
  Android.androidRegionCheck();
}

function sessionExpiredIos(){
  let str = '';
  window.webkit.messageHandlers.sessionExpiredIos.postMessage(str);
}

function androidMailRedirect(str){
  logAndroidCallback('email', 'Android.email', str);
  if (typeof Android !== 'undefined' && Android.email) {
    Android.email(str);
  }
}

function androidWhatsappRedirect(str){
  logAndroidCallback('whatsapp', 'Android.whatsapp', str);
  if (typeof Android !== 'undefined' && Android.whatsapp) {
    Android.whatsapp(str);
  }
}

function androidPhoneRedirect(str){
  logAndroidCallback('phone', 'Android.phone', str);
  if (typeof Android !== 'undefined' && Android.phone) {
    Android.phone(str);
  }
}

function termsAndroid(){
  logAndroidCallback('termsAndroid', 'Android.termsAndroid');
  Android.termsAndroid();
}

function termsIos(){
  let str = '';
  window.webkit.messageHandlers.termsIos.postMessage(str);
}

function redirectToHomeAndroid(){
  logAndroidCallback('redirectToHome', 'Android.redirectToHomeAndroid');
  Android.redirectToHomeAndroid();
}

function redirectToHomeIos(){
  let str = '';
  window.webkit.messageHandlers.redirectToHomeIos.postMessage(str);
}

function liveChannelRedirect(catalog_id, content_id){
  logAndroidCallback('liveChannelRedirect', 'Android.liveChannelRedirect', {
    catalog_id: catalog_id,
    content_id: content_id,
  });
  Android.liveChannelRedirect(catalog_id, content_id);
}

function iosSuccessCallback(str){
  window.webkit.messageHandlers.success.postMessage(str);
}

function iosFailedCallback(str){
  window.webkit.messageHandlers.failure.postMessage(str);
}

function iosInitCallBack(str){
  window.webkit.messageHandlers.init.postMessage(str);
}

function liveChannelRedirectIos(obj){
  console.log('liveChannelRedirectIos', obj)
  window.webkit.messageHandlers.liveChannelRedirectIos.postMessage(obj);
}

function iosUrlRedirect(url){
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosUrlRedirect) {
    window.webkit.messageHandlers.iosUrlRedirect.postMessage(url);
  }
}

function initiateGpayAndroid(response){
  str = response.payment_dat.google_product_id +"|"+response.payment_dat.transaction_id +"|"+response.payment_dat.price+"|"+response.payment_dat.selectedCurrency+"|"+response.payment_dat.plan_type+"|"+response.payment_dat.plan_name+"|"+ response.payment_dat.coupon_code+"|"+response.payment_dat.coupon_code_type+"|"+response.payment_dat.coupon_code_name+"|"+response.payment_dat.t_action+"|"+response.payment_dat.transaction_id+"|"+response.payment_dat.campaign_name;
  logAndroidCallback('doGooglepayment', 'Android.doGooglepayment', str);
  Android.doGooglepayment(str)
}
// function initiateGpayAndroid(response){
//   console.log('initiateGpayAndroid')
//    Android.doGooglepayment(response.payment_dat.google_product_id,response.payment_dat.transaction_id,response.payment_dat.price,response.payment_dat.selectedCurrency);
// }

// function stripePayment(data, key){
//   // const stripe = Stripe('pk_test_51IsvYiSF0OpLcX4j0ELrPc7I6NCQ3OQxCKk4NkBfnWa36wXLCmxPD2K5mzYwXN9rpMRIefg97bP5mn7P4E2okJEk00xC7rc9gj');
//   const stripe = Stripe(key);
//   stripe.redirectToCheckout({
//     // Make the id field from the Checkout Session creation API response
//     // available to this file, so you can provide it as parameter here
//     // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
//     sessionId: data['id']
//   }).then(function (result) {
//     // If `redirectToCheckout` fails due to a browser or network
//     // error, display the localized error message to your customer
//     // using `result.error.message`.
//     console.log(result.error.message);
//   });
// }



// callback.prototype.success = function(str){Android.success(str)};

// callback.prototype.failed = function(str){Android.failed(str)};